export class UpdateExpedienteRequest {
  public id!: number;
  public descripcion!: string;
  public observaciones!: string;
  public fechaModificacion!: Date;
  public idUsuario!: number;
  public ubicacion!: string;
  public numeroCarpeta!: string;
  public numeroArchivo!: string;
  public responsable!: string;
  public separadorCaratula!: string;
  public caratula!: string;
  public identificadorUnico!: string;
  public numero!: string;
  public demanda!: string;
  public demandado!: string;
  public causa!: string;
  public idEstadoExpediente!: number;
  public idJuzgado!: number;
  public idTipoExpediente!: number;
  public claveExpediente!: string;
  public sufijo!: string;
  public bis!: string;
  public fechaIngresoMEU!: Date;
  public montoDemanda: number = 0;
  public idEstadoProcesal!: number;
  public idCaso!: number;
  public fechaInicio!: Date;
  public fechaFin!: Date;
  public idTipoGrupoExpediente!: number;
  public idTipoPrioridad!: number;
  public etiquetas!: string;
  public tokenAcceso!: string;
  public urlGestion!: string;
  public idTipoMonedaMontoDemanda!: number;
}
